export default "__VITE_ASSET__Crua9YxO__"